import { APPLE_PAY_DETAILS_FORMAT } from 'constant/applePayConstants';

/**
 * Parses an Apple Pay payment method into its internal structure.
 *
 * If the payment method does not have last four digits, returns null.
 * Otherwise, returns an object with card type, expiration, last four digits, and wallet type.
 *
 * @param paymentMethod The payment method object to be parsed.
 * @returns The internal Apple Pay structure or null if not applicable.
 */
export const parseApplePayToInternalStructure = paymentMethod => {
  if (!paymentMethod?.lastFourDigits) {
    return null;
  }
  return {
    cardType: paymentMethod?.cardType,
    expiration: paymentMethod?.expiration,
    lastFourDigits: paymentMethod?.lastFourDigits,
    walletType: paymentMethod?.walletType,
  };
};

/**
 * Parses the Apple Pay expiration date into a formatted string.
 *
 * If the expiration date is missing, returns an empty string.
 * Otherwise, extracts the month and year from the expiration string
 * and formats them using APPLE_PAY_DETAILS_FORMAT.
 *
 * @param {string} expiration The expiration date string in MMYY format.
 * @returns {string} The formatted Apple Pay expiration details string, or an empty string if not applicable.
 */
export const parseApplePayDetails = expiration => {
  if (!expiration) {
    return '';
  }

  const [month, year] = [
    expiration.substring(0, 2),
    expiration.substring(2, 4),
  ];
  return APPLE_PAY_DETAILS_FORMAT.replace('%s', month).replace('%s', year);
};
